// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-container {
  max-width: 430px;
  max-height: 932px;
  height: 100vh;
  border-radius: 40px;
  padding: 20px;
  height: 97vh;
  background-color: #f8f8f7;
  font-family: 'Helvetica Neue', sans-serif;
}

.material-icons {
  font-size: 36px;
}

.material-iconsNotes {
  font-size: 2em !important;
}

.active {
  color: blue;
}


.display-section {
  background-color: #f8f8f7;
  text-align: center;
  height: 10em;
  padding: 20px 0;
  border-bottom: 1px solid #d1d1d1;
}

.number-display {
  font-size: 32px;
  color: #000;
  margin-bottom: 10px;
}

.add-number {
  font-size: 18px;
  color: #007aff;
}

.dial-pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  padding: 20px;
}

.dial-button {
  background-color: #b2b2b2;
  border-radius: 100%;
  height: 100px;
  width: 100%;
  font-size: 26px;
  color: #000;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.dial-button:active {
  background-color: #e5e5e5;
}

.call-button {
  background-color: #4cd964;
  color: white;
  padding-bottom: 3px;
  border: none;
  border-radius: .5em;
  padding-top: 3px;
  width: 91vw;
  max-width: 400px;
  height: 4.5em;
  margin-bottom: 5px;

}

.delete-button {
  font-size: 30px;
  border: none;
  background: none;
  position: fixed;
  right: 25px;
}

.phone-footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
  background-color: #f8f8f7;
  border-top: 1px solid #d1d1d1;
}

.footer-icon {
  font-size: 30px;
  color: #007aff;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Phone.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".phone-container {\n  max-width: 430px;\n  max-height: 932px;\n  height: 100vh;\n  border-radius: 40px;\n  padding: 20px;\n  height: 97vh;\n  background-color: #f8f8f7;\n  font-family: 'Helvetica Neue', sans-serif;\n}\n\n.material-icons {\n  font-size: 36px;\n}\n\n.material-iconsNotes {\n  font-size: 2em !important;\n}\n\n.active {\n  color: blue;\n}\n\n\n.display-section {\n  background-color: #f8f8f7;\n  text-align: center;\n  height: 10em;\n  padding: 20px 0;\n  border-bottom: 1px solid #d1d1d1;\n}\n\n.number-display {\n  font-size: 32px;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.add-number {\n  font-size: 18px;\n  color: #007aff;\n}\n\n.dial-pad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 15px;\n  padding: 20px;\n}\n\n.dial-button {\n  background-color: #b2b2b2;\n  border-radius: 100%;\n  height: 100px;\n  width: 100%;\n  font-size: 26px;\n  color: #000;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.dial-button:active {\n  background-color: #e5e5e5;\n}\n\n.call-button {\n  background-color: #4cd964;\n  color: white;\n  padding-bottom: 3px;\n  border: none;\n  border-radius: .5em;\n  padding-top: 3px;\n  width: 91vw;\n  max-width: 400px;\n  height: 4.5em;\n  margin-bottom: 5px;\n\n}\n\n.delete-button {\n  font-size: 30px;\n  border: none;\n  background: none;\n  position: fixed;\n  right: 25px;\n}\n\n.phone-footer {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 10px 0;\n  background-color: #f8f8f7;\n  border-top: 1px solid #d1d1d1;\n}\n\n.footer-icon {\n  font-size: 30px;\n  color: #007aff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
